import { useMemo } from 'react'

import { type UserMeExEntity } from '@/libs/api'

/**
 * テナントのTMS利用フラグ(isUsingTms)の判定用フック
 * - マルチテナントに対応
 */
export const useTmsVisibility = (
  tenantKey: string,
  authUser: UserMeExEntity
) => {
  const isUsingTms = useMemo(() => {
    const currentTenant = authUser.tenants?.find(
      (tenant) => tenant.key === tenantKey
    )
    return currentTenant?.isUsingTms ?? false
  }, [authUser.tenants, tenantKey])

  return isUsingTms
}
